import { useEffect, type CSSProperties } from 'react';
import { Icon } from './Icon';
import { DESIGN_STYLES } from '../data/designStyles';
import '../styles/stylepicker.css';

// Font display dei 10 Stili — caricati SOLO quando si apre la galleria (è uno
// strumento interno). Se la rete/CSP li blocca, le card ripiegano su serif/sans.
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600' +
  '&family=Playfair+Display:wght@600&family=Archivo:wght@700&family=Fraunces:wght@500' +
  '&family=Hanken+Grotesk:wght@600&family=Newsreader:wght@500&family=Poiret+One' +
  '&family=Zilla+Slab:wght@600&family=Fredoka:wght@500&display=swap';

interface Props {
  current: string;
  onSelect: (id: string) => void;
  onClose: () => void;
}

/** Galleria visiva di scelta dello Stile (popup tipo Word). Click su una card =
 *  seleziona quello Stile e chiude; il salvataggio resta nella scheda. */
export function StylePicker({ current, onSelect, onClose }: Props) {
  useEffect(() => {
    if (!document.getElementById('sp-fonts')) {
      const l = document.createElement('link');
      l.id = 'sp-fonts';
      l.rel = 'stylesheet';
      l.href = FONTS_HREF;
      document.head.appendChild(l);
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="mscrim open" onMouseDown={onClose}>
      <div
        className="modal sp-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Scegli lo stile del sito"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modal-head">
          <h3>Scegli lo stile del sito</h3>
          <button type="button" className="dr-close" onClick={onClose} aria-label="Chiudi">
            <Icon name="x" size={18} />
          </button>
        </div>
        <div className="modal-body sp-body">
          <div className="sp-grid">
            {DESIGN_STYLES.map((s) => {
              const p = s.preview;
              const sel = s.id === current;
              const vars = {
                '--bg': p.bg,
                '--pr': p.primary,
                '--op': p.onPrimary,
                '--ac': p.accent,
                '--oa': p.onAccent,
                '--tx': p.text,
                '--ff': p.font,
              } as CSSProperties;
              return (
                <button
                  key={s.id}
                  type="button"
                  className={'sp-card' + (sel ? ' sel' : '')}
                  aria-pressed={sel}
                  onClick={() => onSelect(s.id)}
                  style={vars}
                >
                  <span className="sp-thumb">
                    {sel && <span className="sp-badge">Attuale</span>}
                    <span className="sp-hero">
                      <span className="sp-eb">Ristorante</span>
                      <span className="sp-name">Da Lucia</span>
                    </span>
                    <span className="sp-body2">
                      <span className="sp-l" style={{ width: '80%' }} />
                      <span className="sp-l" style={{ width: '95%' }} />
                      <span className="sp-l" style={{ width: '55%' }} />
                      <span className="sp-btn">Prenota</span>
                    </span>
                  </span>
                  <span className="sp-label">{s.label}</span>
                  <span className="sp-sub">{s.suited}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
